import React from "react"
import ReactDom from "react-dom"

import View from "../views/tada"

// if (window.drupalSettings.user.uid === 0) location.href = '/estadio-aguila/iniciar-sesion'


export const page = () => {
  ReactDom.render(<View /> , document.getElementById('app'))
}